(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditNotificationSettings', [
			'globalConfig',
			EditNotificationSettingsFunction
		]);

	function EditNotificationSettingsFunction(globalConfig) {
		var notifications = this;
		
		angular.merge(notifications, globalConfig);
		
		notifications.changeSettings = function(source){
			if (source === 'allEmailOptOut') {
				notifications.serializedForm.receiveMyInvestmentsEmails = false;
				notifications.serializedForm.receiveNewProductsAndFeaturesEmails = false;
				notifications.serializedForm.receiveFundriseContentAndRemindersEmails = false;
				notifications.serializedForm.allEmailOptOut = true;
			} else {
				notifications.serializedForm.allEmailOptOut = false;
			}
		};
	}
})(window.angular);